import React, { useState, useEffect } from 'react';
import CarSummary from './CarSummary';
import API_BASE_URL from './config';

function CarSummarySelector() {
  const [cars, setCars] = useState([]);
  const [selectedCarId, setSelectedCarId] = useState('');

  useEffect(() => {
    fetch(`${API_BASE_URL}/cars`)
      .then(res => res.json())
      .then(data => setCars(data));
  }, []);

  return (
    <div>
      <label>اختر اسم العربية:</label>
      <select value={selectedCarId} onChange={e => setSelectedCarId(e.target.value)}>
        <option value="">-- اختر --</option>
        {cars.map(car => (
          <option key={car.id} value={car.id}>{car.name}</option>
        ))}
      </select>
      <CarSummary carId={selectedCarId} />
    </div>
  );
}

export default CarSummarySelector;
